import React from 'react';
import { getVendorFileArchiveData } from 'utils/apiRequests';

import { VendorFileArchiveContext } from '.';

export class VendorFileArchiveContextProvider extends React.Component {
	state = {
		fileArchive: null,
		isFetching: false,
	};

	componentDidMount() {
		this.fetchData();
	}

	fetchData = () => {
		this.setState({ isFetching: true });
		getVendorFileArchiveData()
			.then(fileArchive => {
				this.setState({ fileArchive });
				this.setState({ isFetching: false });
			})
			.catch(() => {
				this.setState({ fileArchive: [] });
				this.setState({ isFetching: false });
			});
	};

	render() {
		return (
			<VendorFileArchiveContext.Provider
				value={{
					...this.state,
					refetch: this.fetchData,
				}}
			>
				{this.state.fileArchive ? this.props.children : null}
			</VendorFileArchiveContext.Provider>
		);
	}
}
